var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackToTop({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.057 14.276c.521.52 1.365.52 1.886 0l5.724-5.724v18.189c0 .695.597 1.259 1.333 1.259s1.334-.564 1.334-1.26V8.553l5.723 5.724a1.333 1.333 0 1 0 1.886-1.886l-8-8a1.333 1.333 0 0 0-1.886 0l-8 8c-.52.521-.52 1.365 0 1.886z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackToTop);
export default __webpack_public_path__ + "static/media/back-to-top.806b39f85033a797de0eb77254580bba.svg";
export { ForwardRef as ReactComponent };